import { UserButton, useUser } from '@clerk/clerk-react'
import { Settings } from 'lucide-react'
import { Outlet } from 'react-router-dom'

import { DefaultClinicSelector } from '@/frontend/components/default-clinic-selector'
import { AppBreadcrumbs } from '@/frontend/components/layout/app-breadcrumbs'
import { AppSearch } from '@/frontend/components/layout/app-search'
import { EnvironmentBanner } from '@/frontend/components/layout/environment-banner'
import { SidebarInset, SidebarProvider } from '@/frontend/components/ui/sidebar'
import { UserSettings } from '@/frontend/components/user-settings'
import { RegionProvider } from '@/frontend/features/region/region-context'
import { RegionSwitcher } from '@/frontend/features/region/region-switcher'

import { AppSidebar } from './app-sidebar'

export function AppLayout() {
  const { user } = useUser()

  return (
    <RegionProvider>
      <EnvironmentBanner />
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset className="min-w-0">
          <header className="flex h-14 items-center justify-between border-b px-4">
            {/* Left — Breadcrumbs */}
            <div className="flex items-center">
              <AppBreadcrumbs />
            </div>

            {/* Right — Clinic, Search, Notifications & User */}
            <div className="flex items-center gap-4">
              <AppSearch />
              {/* The negative margins below are to match perceived icon padding to neighbouring components */}
              <div className="-ml-1 h-5 w-px bg-border" />
              <DefaultClinicSelector variant="chip" />
              <RegionSwitcher />
              <div className="flex items-center gap-2.5">
                {user && (
                  <div className="hidden sm:block">
                    <p className="font-medium leading-none">{user.fullName}</p>
                    {typeof user.publicMetadata?.role === 'string' && (
                      <p className="mt-0.5 text-sm leading-none text-muted-foreground">
                        {user.publicMetadata.role}
                      </p>
                    )}
                  </div>
                )}
                <UserButton appearance={{ elements: { avatarBox: 'size-7' } }}>
                  <UserButton.MenuItems>
                    <UserButton.Action
                      label="Settings"
                      labelIcon={<Settings className="size-4" />}
                      open="user-settings"
                    />
                  </UserButton.MenuItems>
                  <UserButton.UserProfilePage
                    label="Settings"
                    labelIcon={<Settings className="size-4" />}
                    url="user-settings"
                  >
                    <UserSettings />
                  </UserButton.UserProfilePage>
                </UserButton>
              </div>
            </div>
          </header>
          <div className="w-full flex-1 bg-background p-4 2xl:p-5">
            <Outlet />
          </div>
        </SidebarInset>
      </SidebarProvider>
    </RegionProvider>
  )
}
